export const DASHBOARD_TEST_LABELS = {
  DRAWER_TITLE: 'dashboard-drawer-title',
  DIALOG_DELETE_BUTTON: 'dashboard-dialog-delete-button',
  RECTANGLE: 'dashboard-rectangle',
  LIVE_DATA_LABEL: 'dashboard-live-data-label',
} as const;

export type DashboardTestLabel = (typeof DASHBOARD_TEST_LABELS)[keyof typeof DASHBOARD_TEST_LABELS];
